import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  dev: {
    apiKey: "AIzaSyBEP3FZXesVoH7YPKtoBvAhGWM8DH3pbNo",
    authDomain: "powerfront-scheduler-dev.firebaseapp.com",
    databaseURL: "https://powerfront-scheduler-dev.firebaseio.com",
    projectId: "powerfront-scheduler-dev",
    storageBucket: "powerfront-scheduler-dev.appspot.com",
    messagingSenderId: "791099239012",
    appId: "1:791099239012:web:2dcd17994ddb732915cd71",
  },
  sandbox: {
    apiKey: "AIzaSyABUHdNSYQdOXAUVaHa3-Wqins3qrsBcJg",
    authDomain: "powerfront-scheduler-sandbox.firebaseapp.com",
    databaseURL: "https://powerfront-scheduler-sandbox.firebaseio.com",
    projectId: "powerfront-scheduler-sandbox",
    storageBucket: "powerfront-scheduler-sandbox.appspot.com",
    messagingSenderId: "939550565473",
    appId: "1:939550565473:web:cf2f25a23236904f93b620",
  },
  production: {
    apiKey: "AIzaSyDHKNrVNmeGq4kcRfZgicwNGX4r-eNS6V8",
    authDomain: "powerfront-scheduler.firebaseapp.com",
    databaseURL: "https://powerfront-scheduler.firebaseio.com",
    projectId: "powerfront-scheduler",
    storageBucket: "powerfront-scheduler.appspot.com",
    messagingSenderId: "348265271568",
    appId: "1:348265271568:web:504283bd2696db4b6b5595",
  },
};

//DEV
// const firebaseConfig = {
//   apiKey: "AIzaSyBEP3FZXesVoH7YPKtoBvAhGWM8DH3pbNo",
//   authDomain: "powerfront-scheduler-dev.firebaseapp.com",
//   databaseURL: "https://powerfront-scheduler-dev.firebaseio.com",
//   projectId: "powerfront-scheduler-dev",
//   storageBucket: "powerfront-scheduler-dev.appspot.com",
//   messagingSenderId: "791099239012",
//   appId: "1:791099239012:web:2dcd17994ddb732915cd71",
// };

//Sandbox
// const firebaseConfig = {
//   apiKey: "AIzaSyABUHdNSYQdOXAUVaHa3-Wqins3qrsBcJg",
//   authDomain: "powerfront-scheduler-sandbox.firebaseapp.com",
//   databaseURL: "https://powerfront-scheduler-sandbox.firebaseio.com",
//   projectId: "powerfront-scheduler-sandbox",
//   storageBucket: "powerfront-scheduler-sandbox.appspot.com",
//   messagingSenderId: "939550565473",
//   appId: "1:939550565473:web:cf2f25a23236904f93b620",
// };

//PROD
// const firebaseConfig = {
//     apiKey: "AIzaSyDHKNrVNmeGq4kcRfZgicwNGX4r-eNS6V8",
//     authDomain: "powerfront-scheduler.firebaseapp.com",
//     databaseURL: "https://powerfront-scheduler.firebaseio.com",
//     projectId: "powerfront-scheduler",
//     storageBucket: "powerfront-scheduler.appspot.com",
//     messagingSenderId: "348265271568",
//     appId: "1:348265271568:web:504283bd2696db4b6b5595"
// };

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig[process.env.REACT_APP_ENV]);
}

const projectId = firebaseConfig[process.env.REACT_APP_ENV].projectId;

let config = {
  firebase: firebase,
  firestore: firebase.firestore(),
  mailUrl: `https://us-central1-${projectId}.cloudfunctions.net/mail`,
  ctsUrl: "https://us-central1-callthestore-dev.cloudfunctions.net/",
  //ctsUrl: "https://us-central1-call-the-store-sandbox.cloudfunctions.net/",
  //ctsUrl: "https://us-central1-powerfront-video-assistant.cloudfunctions.net/",
};

export default config;
